import { useCallback } from 'react';

import { TrackingApi } from 'api/TrackingApi';
import { getScreenOrientationWithSizes } from 'helpers/device';

export const useHeaderMenuAnalytics = () => {
  const trackClickOnFinder = useCallback(() => {
    TrackingApi.trackClick({
      info: 'finder_old',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);
  const trackClickOnThreads = useCallback(() => {
    TrackingApi.trackClick({
      info: 'chats_old',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);
  const trackClickOnActivity = useCallback(() => {
    TrackingApi.trackClick({
      info: 'activity_old',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);
  const trackClickOnMyProfile = useCallback(() => {
    TrackingApi.trackClick({
      info: 'myprofile_old',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  return {
    trackClickOnFinder,
    trackClickOnThreads,
    trackClickOnActivity,
    trackClickOnMyProfile,
  };
};
